import { formatCurrency } from '@/services/convert'

export const getChartColors = ['#a2dd86', '#66b3ff', '#ffff33', '#e62e00', '#71283e', '#333333',
  '#bdc3c7', '#83bff5', '#1aa3ff', '#0059b3', '#4080bf', '#3366cc', '#ff3300', '#ff0000', '#ff4d4d',
  '#cc0000', '#00e6e6', '#339933', '#00cc66', '#009933', '#666600', '#666633', '#ff9900', '#cc6600',
  '#ff0066', '#e6e600', '#53ff1a', '#333399', '#ff66ff', '#c6538c', '#e63900', '#993399', '#999966',
  '#ff5050', '#003366', '#336699', '#003399', '#000099', '#0000cc', '#000066', '#008B8B', '#2E8B57',
  '#4169E1', '#483D8B', '#6B8E23', '#CD853F', '#006666', '#006699', '#0099cc', '#0066cc', '#0033cc',
  '#339966', '#00cc99', '#66ffcc', '#336600', '#009900', '#66ff33', '#333300']

export const getChartOptions = {
  chart: {
    type: 'donut',
  },
  labels: [],
  dataLabels: {
    enabled: false,
    textAnchor: 'start',
    style: {
      colors: ['#fff'],
    },
    offsetX: 0,
    dropShadow: {
      enabled: true,
      left: 2,
      top: 2,
      opacity: 0.3,
    },
    formatter: function(val, opt) {
      return formatCurrency(opt['w']['config']['series'][opt.seriesIndex])
    },
  },
  legend: {
    show: false,
    showForSingleSeries: false,
    showForNullSeries: true,
    showForZeroSeries: true,
    position: 'bottom',
    horizontalAlign: 'left',
    floating: false,
    fontSize: '13px',
    fontWeight: 600,
    formatter: function(val, opt) {
      return (
        val +
        ' - ' +
        formatCurrency(opt['w']['config']['series'][opt.seriesIndex])
      )
    },
  },
  colors: getChartColors,
  tooltip: {
    enabled: true,
    style: {
      fontSize: '12px',
      fontWeight: 500,
    },
    onDatasetHover: {
      highlightDataSeries: true,
    },
    custom: function({ series, seriesIndex, dataPointIndex, w }) {
      return (
        '<div style="padding: 5px; z-index: 99; opacity: 1; position: relative; text-align: center;">' +
          '<span>' + w['config']['labels'][seriesIndex] +
            ' <span style="display: block;"> ' + formatCurrency(w['config']['series'][seriesIndex]) + '</span>' +
          '</span>' +
        '</div>'
      )
    },
  },
  responsive: [
    {
      breakpoint: 200,
      options: {
        chart: {
          width: '100%',
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
      },
    },
  ],
  plotOptions: {
    pie: {
      donut: {
        size: '0%',
      },
      expandOnClick: false,
    },
  },
}

export const addAssets = (data) => {
  const assets = []
  data.forEach(element => {
    element.asset_Details.forEach(element => {
      const cost = isNaN(element.cost) ? 0 : Number(element.cost.toFixed(2))
      const isPresent = assets.some(i => i.asset_Type === element.asset_Type)
      if (!isPresent) {
        assets.push({
          asset_Type: element.asset_Type,
          cost: cost,
        })
      } else {
        const index = assets.findIndex(i => i.asset_Type === element.asset_Type)
        assets[index]['cost'] = assets[index]['cost'] + cost
      }
    })
  })
  return assets
}
